import * as Yup from 'yup';
import type { YupFormValidationSchema } from '../../../../../../types/common/utility';

const baseMailingAddressValidation = Yup.object().shape({
  address1: Yup.string().required('Mailing address is required'),
  city: Yup.string().required('Mailing city is required'),
  zipCode: Yup.string().required('Mailing postal code is required'),
});

export const createMailingAddressSchema = (
  languageFormSchema: YupFormValidationSchema
) =>
  baseMailingAddressValidation.shape({
    zipCode:
      languageFormSchema.zipCode?.label('Mailing Postal Code') ||
      baseMailingAddressValidation.fields.zipCode,
  });

export const useAccountInfoFormFieldValidationSchema = (
  languageFormSchema: YupFormValidationSchema
): Yup.ObjectSchema =>
  Yup.object().shape({
    name: Yup.string().trim().required().label('Account Name'),
    ...languageFormSchema,
  });

export const useAccountInfoFormFieldWithMailingAddressValidationSchema = (
  languageFormSchema: YupFormValidationSchema,
  mailingAddressFeatureOn: boolean
): Yup.ObjectSchema => {
  const baseSchema =
    useAccountInfoFormFieldValidationSchema(languageFormSchema);

  return mailingAddressFeatureOn
    ? baseSchema.shape({
        mailingAddress: createMailingAddressSchema(languageFormSchema),
      })
    : baseSchema;
};

export const useMailingAddressValidationSchema = (
  mailingAddressFeatureOn: boolean,
  languageFormSchema?: YupFormValidationSchema
): Yup.ObjectSchema =>
  mailingAddressFeatureOn
    ? Yup.object().shape({
        mailingAddress: languageFormSchema
          ? createMailingAddressSchema(languageFormSchema)
          : baseMailingAddressValidation,
      })
    : Yup.object().shape({});
